import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { Customer } from '../../models/customer';
import { State } from '../../services/global-state';
import { HpfConsumerService, RemoveCustomersFromConsumerUserRequest } from '../../services/hpf-consumer.service';
import { PayrazrService } from '../../services/payrazr';
import { ValidationController, ValidationControllerFactory } from 'aurelia-validation';

@autoinject
export class GridRemoveCustomer {

	validationController: ValidationController;

	associatedCustomers: Array<Customer>;

	selectedRows: Array<number> = [];

	currentPage: number;
	pageSize: number = 10;
	totalItems: number;

	constructor(
		private globalState: State,
		private i18n: I18N,
		private consumerService: HpfConsumerService,
		private payrazrService: PayrazrService,
		private router: Router,
		validationControllerFactory: ValidationControllerFactory) {

		this.validationController = validationControllerFactory.createForCurrentScope(); 
	}

	attached() {
		this.payrazrService.refreshGlobalCustomer()
			.then((response: State) => {
				this.globalState = response;
				this.update();
			});
	}

	update() {
		this.associatedCustomers = this.globalState.associatedCustomers;
		this.totalItems = this.associatedCustomers.length;
	}

	remove() {
		this.validationController.errors = [];

		if (!this.selectedRows.length) {
			return;
		}

		let isConfirmed = confirm(this.i18n.i18next
			.t('confirmRemoveCustomer', 'Are you sure you want to remove this customer?'));

		if (!isConfirmed) {
			return;
		}

		let request = new RemoveCustomersFromConsumerUserRequest();
		request.customerKeys = this.selectedRows;
		this.consumerService.removeCustomersFromConsumerUser(request)
			.then(response => {
				if (!response.isSuccessful) {
					throw new Error(response.resultMessage);
				}

				alert(this.i18n.i18next
					.t('customersSuccessfullyRemoved', 'Customer(s) successfully removed.'));

				this.router.navigateToRoute('dashboard');
			})
			.catch(reason => {
				this.validationController.errors = this.validationController.errors
					.concat([reason.message]);
			});
	}
}
